import request from './request';

// 状态分布统计-图表
export function getClueStatus(params) {
    return request('/stat/clue/status/view', {
        method: 'POST',
        params,
    });
}

// 状态分布统计-列表
export function getClueStatusList(params) {
    return request('/stat/clue/status/list', {
        method: 'POST',
        params,
    });
}
